<template>
  <div>
    <div class="situtionStyleWrapp">
      <div class="situtionStyle">
        <div class="insStyle">
          <a-icon :component="IconOrderedList" style="margin-right: 10px" />请先完成情形题，将展示与你情况对应的材料
          <span style="float:right;margin-right:20px;text-decoration:underline;;cursor: pointer;" @click="cancelClose">展示所有材料</span>
        </div>
        <div style="margin-top:23px;padding-bottom: 14px;border: 1px solid rgba(238,238,238,1);;padding-top: 19px;">
          <div
            style="margin: 0px 20px; font-weight: bold; list-style: none"
            ref="listLi"
            :class="[item.activeStyle?'activeStyle':'']"
            v-for="(item, index) in listOfSituations"
            :key="item.iid"
            class="btn">
            <span style="margin-right:3px">{{ item.index?item.index+'、':'' }}</span>
            <span>({{ item.selectType === 'single'?'单选':'多选' }})</span>{{ item.customName || item.situationName }}
            <div style="margin: 30px 0px">
              <a-radio-group style="width:800px" v-if="item.childList && item.selectType === 'single'" v-model="item.checked" @change="handleRadioChecked(item.checked, index, item)">
                <a-radio
                  v-for="sub in item.childList"
                  :key="sub.iid"
                  @click="handleStyleClick2(sub,item.childList)"
                  :value="sub.iid"
                  :class="[sub.active==='active'?'active':'']"
                  style="border:1px solid #ddd;padding:4px 10px;border-radius:3px;margin-right: 8px;margin-bottom: 8px;">
                  {{ sub.customName || sub.situationName }}
                  <!-- <a-tooltip placement="topLeft" v-if="sub.insContent">
                  <template #title v-if="sub.insContent || sub.dicId">
                    <div v-if="sub.insContent">选项说明<span v-html="sub.insContent"></span></div>
                  </template>
                  <a-icon type="info-circle" />
                </a-tooltip> -->
                  <!-- 自动弹出提示 -->
                  <a-modal
                    v-model="sub.visible"
                    :footer="null"
                    :closable="false"
                    width="420px" >
                    <a-row style="padding:8px">
                      <a-col :span="20"><p class="info" v-html="sub.optionvalexplanation"></p></a-col>
                    </a-row>
                    <div style="text-align:right;">
                      <a-button key="cancel" type="primary" style="margin-right:5px" @click="refill(sub,item.childList)">
                        我知道了
                      </a-button>
                    </div>
                  </a-modal>
                  <!-- 手动弹出提示 -->
                  <a-icon type="info-circle" v-if="sub.optionvalexplanationtype === 'direct'" @click="explainModal(sub)" />
                </a-radio>

              </a-radio-group>
              <a-checkbox-group v-if="item.childList && item.selectType === 'multiple'" v-model="item.checked" @change="handleCheckboxChange(item.checked, index, item)">
                <a-checkbox
                  v-for="sub in item.childList"
                  :key="sub.iid"
                  @click="handleStyleClick(sub, item.childList)"
                  :class="[sub.active==='active'?'active':'']"
                  :value="sub.iid"
                  style="border:1px solid #ddd;padding:4px 10px;border-radius:3px;margin-right: 8px;margin-bottom: 8px;">
                  {{ sub.customName || sub.situationName }}
                  <!-- <a-tooltip v-if="sub.insContent || sub.dicId">
                  <template #title v-if="sub.insContent || sub.dicId">
                    <div v-if="sub.insContent">备注名字： <span v-html="sub.insContent"></span></div>
                  </template>
                  <a-icon type="info-circle" />
                </a-tooltip> -->
                  <a-icon type="info-circle" v-if="sub.optionvalexplanationtype === 'direct'" @click="explainModal2(sub)" />
                </a-checkbox>
              </a-checkbox-group>
            </div>
          </div>
          <div class="sureStyle" v-if="listOfSituations && listOfSituations.length > 0">
            <span @click="refGetIds">确定，查看材料</span>
          </div>
        </div>
      </div>

      <a-modal
        v-model="visible"
        :footer="null"
        :closable="false"
        :maskClosable="true"
        width="420px" >
        <a-row style="padding:8px">
          <a-col :span="20"><p class="info" v-html="optionvalexplanation"></p></a-col>
        </a-row>
        <div style="text-align:right;">
          <a-button key="cancel" type="primary" style="margin-right:5px" @click="refill2">
            我知道了
          </a-button>
        </div>
      </a-modal>
    </div>
  </div>

</template>
<script>
import { cloneDeep } from 'lodash'
import IconOrderedList from '@ant-design/icons/svg/outline/ordered-list.svg?inline'
import { jiopAPI } from '@/api/jiopweb/jiop'
export default {
  // 情形选择
  name: 'StepOne',
  data () {
    return {
      IconOrderedList,
      originData: [],
      situationIds: [],
      situationIdsTemp: [],
      listOfSituations: [],
      startTempSituations: [],
      startTempSituationIds: [],
      result: [],
      ids: [],
      setSituids: [], // 点击确定获取的选中的情形id值得集合
      acceptCode: '',
      checkNowIds: {},
      visible: false,
      optionvalexplanation: ''
    }
  },
  props: {
    itemType: {
      type: String,
      default: ''
    },
    situationDataBeanList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    }
  },
  methods: {
    // 单选关闭
    refill (sub, list) {
      sub.visible = false
      list.map(item => {
        item.active = 'none'
      })
      sub.active = 'active'
    },
    refill2 () {
      this.visible = false
    },
    explainModal (sub) {
      if (sub.optionvalexplanationtype === 'direct') {
        sub.visible = true
      }
    },
    explainModal2 (sub) {
      if (sub.optionvalexplanationtype === 'direct') {
        this.visible = true
        this.optionvalexplanation = sub.optionvalexplanation
      }
    },
    cancelClose () {
      this.$emit('isShowSitution', false, ',')
    },
    reset () {
      if (this.acceptCode) {
        this.getTemporary()
      } else {
        this.listOfSituations = cloneDeep(this.originData)
      }
    },
    findList (list, checkedId) {
      if (Array.list) {
        list.find(item => {
          if (item.iid === checkedId) {
            return item
          } else if (item.childList) {
            this.findList(item.list, checkedId)
          }
        })
      }
    },
    // 单选选中处理方式
    handleRadioChecked (checkedId, index, item) {
      if (item.childList) {
        // 获取当前选择节点 的 同级别 其他所有未选择节点
        const restIidList = item.childList.reduce((prev, current) => {
          if (current.iid !== checkedId) {
            if (current.childList) {
              const iid = Array.from(current.childList, item => item.iid)
              prev = prev.concat(iid)
            }
          }
          return prev
        }, [])
        const childrenIds = []
        const getChildId = tree => {
          if (tree && tree.length) {
            tree.forEach(item => {
              if (item.childList && item.childList.length) {
                item.childList.forEach(itemChild => {
                  childrenIds.push(itemChild.iid)
                  if (itemChild.childList && itemChild.childList.length) {
                    getChildId(itemChild.childList)
                  }
                })
              }
            })
          }
        }
        getChildId(item.childList)
        // 过滤 不在当前未选择节点中的元素
        // this.listOfSituations.map(item => {
        //   if (restIidList.indexOf(item.iid) !== -1) {
        //     this.removeList(item)
        //   }
        // })
        this.listOfSituations = this.listOfSituations.filter(
          item => restIidList.concat(childrenIds).indexOf(item.iid) === -1
        )
        // 插入当前 选择元素下的 子元素
        const target = item.childList.find(item => item.iid === checkedId)
        if (target.childList) {
          const targetTemp = cloneDeep(target)
          if (targetTemp?.childList && targetTemp?.childList.length > 0) {
            targetTemp.childList[0].activeStyle = true
          }

          // this.listOfSituations = [...this.listOfSituations, ...target.childList]
          // this.listOfSituations.splice(index + 1, 0, ...target.childList)
          let rest = cloneDeep(this.listOfSituations)
          const list = cloneDeep(targetTemp.childList)
          list.forEach(it => {
            if (it.selectType === 'multiple') {
              it.checked = []
            }
            if (it.selectType === 'single') {
              it.checked = ''
            }
          })

          rest.splice(index + 1, 0, ...list)
          rest = this.unique(rest, 'iid')
          this.listOfSituations = rest
        }
      }
    },
    // 单选清楚子选项处理方式
    removeList (item) {
      if (this.listOfSituations.length > 0) {
        this.listOfSituations = this.listOfSituations.filter(li => {
          if (li.iid === item.iid) {
            return false
          } else {
            return true
          }
        })
        if (item.childList) {
          item.childList.map(items => {
            this.removeList(items)
          })
        }
      }
      return item
    },
    handleCheckboxChange (checkedList, index, item) {
      this.checkNowIds[item.iid] = this.checkNowIds[item.iid] ? this.checkNowIds[item.iid] : []
      // const oldLength = this.checkNowIds[item.iid].length
      const targetId = this.clacdiff(checkedList, this.checkNowIds[item.iid])
      this.checkNowIds[item.iid] = checkedList
      // const newLength = this.checkNowIds[item.iid].length
      if (item.childList) {
        // 获取当前选择节点的同级别其他所有未选择节点
        const restIidList = item.childList.reduce((prev, current) => {
          if (!checkedList.includes(current.iid)) {
            if (current.childList) {
              const iid = Array.from(current.childList, item => item.iid)
              prev = prev.concat(iid)
            }
          }
          return prev
        }, [])
        const childrenIds = []
        const getChildId = tree => {
          if (tree && tree.length) {
            tree.forEach(item => {
              if (item.childList && item.childList.length) {
                item.childList.forEach(itemChild => {
                  childrenIds.push(itemChild.iid)
                  if (itemChild.childList && itemChild.childList.length) {
                    getChildId(itemChild.childList)
                  }
                })
              }
            })
          }
        }
        getChildId(
          targetId && targetId.length
            ? item.childList.filter(item => targetId.includes(item.iid))
            : item.childList.filter(it => !this.checkNowIds[item.iid].includes(it.iid))
        )
        // 过滤 不在当前未选择节点中的元素
        this.listOfSituations = this.listOfSituations.filter(
          item => restIidList.concat(childrenIds).indexOf(item.iid) === -1
        )
        // 插入当前 选择元素下的 子元素
        const target = item.childList.find(it =>
          targetId && targetId.length
            ? targetId.includes(it.iid)
            : this.checkNowIds[item.iid].includes(it.iid)
        )
        // oldLength < newLength &&

        if (target?.childList && target?.childList.length > 0) {
          const targetTemp = cloneDeep(target)
          targetTemp.childList[0].activeStyle = true
          let rest = cloneDeep(this.listOfSituations)
          const list = cloneDeep(targetTemp.childList)
          list.forEach(it => {
            it.checked = null
          })
          rest.splice(index + 1, 0, ...list)
          rest = this.unique(rest, 'iid')
          this.listOfSituations = rest
        }
      }
    },
    handleStyleClick (sub, list) {
      list.map(item => {
        item.active = 'none'
      })
      sub.active = 'active'
    },
    // 多选点击
    handleStyleClick2 (sub, list) {
      if (sub.optionvalexplanationtype === 'modal') {
        this.visible = true
        this.optionvalexplanation = sub.optionvalexplanation
      }
    },
    unique (arr, uKey) {
      const obj = {}
      const result = []
      arr.forEach(item => {
        const typeofKey = typeof item[uKey] + item[uKey]
        obj[typeofKey] = item
      })
      for (const key in obj) {
        result.push(obj[key])
      }
      return result
    },
    // 多选清除子选项处理方式
    removeMutilpy () { },
    async findSituation () {
      if (this.itemType === 'oneThing') {
        const res2 = this.situationDataBeanList
        res2.map((item, index) => {
          item.index = index + 1
        })
        const target = res2
        this.originData = cloneDeep(target)
        this.listOfSituations = target || []
      } else {
        jiopAPI.findItemBeanSimple({ itemId: this.$route.query.itemId }).then(res => {
          if (res.success) {
            const res2 = res.data.situationDataBeanList
            res2.map((item, index) => {
              item.index = index + 1
            })
            const target = res2
            this.originData = cloneDeep(target)
            this.listOfSituations = target || []
          }
        })
      }

      // const res2 = [
      //   {
      //     'iid': 'a6b68712a4c0ca4085a2770a578a0004',
      //     'delFlag': '0',
      //     'ctime': null,
      //     'createTime': 1645779393566,
      //     'utime': null,
      //     'updateTime': 1645779393566,
      //     'ordernum': 0,
      //     'creatorId': null,
      //     'updateUserId': null,
      //     'overrideDefaulTime': false,
      //     'districtId': 'd2b192d7fecf468a804cfc01003a2365',
      //     'groupId': 'b19a66c3ca6047e880833c1dad6e8da9',
      //     'itemId': 'bae370a901554c389410068a9c09290e',
      //     'situationName': '你喜欢什么',
      //     'situationType': 'option',
      //     'selectType': 'single',
      //     'situationParentId': '0',
      //     'relationId': null,
      //     'relationValue': null,
      //     'childList': [
      //       {
      //         'iid': 'a05733a06715564775634076c5031837',
      //         'delFlag': '0',
      //         'ctime': null,
      //         'createTime': 1645779393577,
      //         'utime': null,
      //         'updateTime': 1645779393577,
      //         'ordernum': 0,
      //         'creatorId': null,
      //         'updateUserId': null,
      //         'overrideDefaulTime': false,
      //         'districtId': 'd2b192d7fecf468a804cfc01003a2365',
      //         'groupId': 'b19a66c3ca6047e880833c1dad6e8da9',
      //         'itemId': 'bae370a901554c389410068a9c09290e',
      //         'situationName': '帅哥',
      //         'situationType': 'value',
      //         'selectType': '',
      //         'situationParentId': 'a6b68712a4c0ca4085a2770a578a0004',
      //         'relationId': null,
      //         'relationValue': null,
      //         'childList': [
      //           {
      //             'iid': '43b1703b31454345b7305b03050a5515',
      //             'delFlag': '0',
      //             'ctime': null,
      //             'createTime': 1645779393589,
      //             'utime': null,
      //             'updateTime': 1645779393589,
      //             'ordernum': 0,
      //             'creatorId': null,
      //             'updateUserId': null,
      //             'overrideDefaulTime': false,
      //             'districtId': 'd2b192d7fecf468a804cfc01003a2365',
      //             'groupId': 'b19a66c3ca6047e880833c1dad6e8da9',
      //             'itemId': 'bae370a901554c389410068a9c09290e',
      //             'situationName': '学习怎么样',
      //             'situationType': 'option',
      //             'selectType': 'single',
      //             'situationParentId': 'a05733a06715564775634076c5031837',
      //             'relationId': null,
      //             'relationValue': null,
      //             'childList': [
      //               {
      //                 'iid': '553b06050056c0451b00378056584501',
      //                 'delFlag': '0',
      //                 'ctime': null,
      //                 'createTime': 1645779393598,
      //                 'utime': null,
      //                 'updateTime': 1645779393598,
      //                 'ordernum': 0,
      //                 'creatorId': null,
      //                 'updateUserId': null,
      //                 'overrideDefaulTime': false,
      //                 'districtId': 'd2b192d7fecf468a804cfc01003a2365',
      //                 'groupId': 'b19a66c3ca6047e880833c1dad6e8da9',
      //                 'itemId': 'bae370a901554c389410068a9c09290e',
      //                 'situationName': '一般',
      //                 'situationType': 'value',
      //                 'selectType': '',
      //                 'situationParentId': '43b1703b31454345b7305b03050a5515',
      //                 'relationId': null,
      //                 'relationValue': null,
      //                 'childList': [

      //                 ],
      //                 'deleted': false
      //               },
      //               {
      //                 'iid': '5a0c05777bc67747a17353c70aa1cb05',
      //                 'delFlag': '0',
      //                 'ctime': null,
      //                 'createTime': 1645779393598,
      //                 'utime': null,
      //                 'updateTime': 1645779393598,
      //                 'ordernum': 0,
      //                 'creatorId': null,
      //                 'updateUserId': null,
      //                 'overrideDefaulTime': false,
      //                 'districtId': 'd2b192d7fecf468a804cfc01003a2365',
      //                 'groupId': 'b19a66c3ca6047e880833c1dad6e8da9',
      //                 'itemId': 'bae370a901554c389410068a9c09290e',
      //                 'situationName': '好',
      //                 'situationType': 'value',
      //                 'selectType': '',
      //                 'situationParentId': '43b1703b31454345b7305b03050a5515',
      //                 'relationId': null,
      //                 'relationValue': null,
      //                 'childList': [

      //                 ],
      //                 'deleted': false
      //               },
      //               {
      //                 'iid': 'a155b507430a5445bc405a7433705a33',
      //                 'delFlag': '0',
      //                 'ctime': null,
      //                 'createTime': 1645779393598,
      //                 'utime': null,
      //                 'updateTime': 1645779393598,
      //                 'ordernum': 0,
      //                 'creatorId': null,
      //                 'updateUserId': null,
      //                 'overrideDefaulTime': false,
      //                 'districtId': 'd2b192d7fecf468a804cfc01003a2365',
      //                 'groupId': 'b19a66c3ca6047e880833c1dad6e8da9',
      //                 'itemId': 'bae370a901554c389410068a9c09290e',
      //                 'situationName': '不好',
      //                 'situationType': 'value',，
      //                 'selectType': '',
      //                 'situationParentId': '43b1703b31454345b7305b03050a5515',
      //                 'relationId': null,
      //                 'relationValue': null,
      //                 'childList': [

      //                 ],
      //                 'deleted': false
      //               }
      //             ],
      //             'deleted': false
      //           }
      //         ],
      //         'deleted': false
      //       },
      //       {
      //         'iid': 'a57001300c45004683031b80a511b00b',
      //         'delFlag': '0',
      //         'ctime': null,
      //         'createTime': 1645779393577,
      //         'utime': null,
      //         'updateTime': 1645779393577,
      //         'ordernum': 0,
      //         'creatorId': null,
      //         'updateUserId': null,
      //         'overrideDefaulTime': false,
      //         'districtId': 'd2b192d7fecf468a804cfc01003a2365',
      //         'groupId': 'b19a66c3ca6047e880833c1dad6e8da9',
      //         'itemId': 'bae370a901554c389410068a9c09290e',
      //         'situationName': '美女',
      //         'situationType': 'value',
      //         'selectType': '',
      //         'situationParentId': 'a6b68712a4c0ca4085a2770a578a0004',
      //         'relationId': null,
      //         'relationValue': null,
      //         'childList': [

      //         ],
      //         'deleted': false
      //       }
      //     ],
      //     'deleted': false
      //   }
      // ]
      // res = res.data.situationDataBeanList
      // res2.map((item, index) => {
      //   item.index = index + 1
      // })
      // const target = res2
      // this.originData = cloneDeep(target)
      // this.listOfSituations = target || []
    },
    getIds (list) {
      this.ids = []
      this.setSituids = []
      if (list !== null) {
        list.forEach((item, index) => {
          if (item?.checked && item?.checked.length) {
            this.ids.push(item.checked)
            const newObj = {}
            newObj[index] = item.checked
            this.setSituids.push(newObj)
          }
        })
      }
    },
    traverseList (list) {
      let str = ''
      list.forEach((item) => {
        if (item.selectType === 'multiple') {
          if (item.checked !== undefined && item.checked !== null && item.checked.length !== 0) {
            item.checked.forEach((item) => {
              str = str + item + ','
            })
          }
        } else {
          if (item.checked !== undefined && item.checked !== null && item.checked !== '') {
          // 有选项被选中
            const checkedId = item.checked
            str = str + checkedId + ','
          }
        }
      })
      str = str.substring(0, str.length - 1)
      return str
    },
    refGetIds () {
      this.getIds(this.listOfSituations)
      const flag = this.ids.length === this.listOfSituations.length
      const target = this.ids.toString()
      const ids = this.traverseList(this.listOfSituations)
      this.$emit('situionIds', ids)
      const setSituits = JSON.stringify(this.setSituids)
      const situationsStr = JSON.stringify(this.listOfSituations)
      return [target, flag, situationsStr, setSituits]
    },
    clacdiff (arr1, arr2) {
      const diff = [...arr1]
      for (let i = 0; i < arr1.length; i++) {
        let flag = false
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i] === arr2[j]) {
            flag = true
          }
        }
        if (flag) {
          diff.splice(
            diff.findIndex(item => item === arr1[i]),
            1
          )
        }
      }
      return diff
    }
  },
  mounted () {
    this.findSituation()
  }
}
</script>
<style scoped lang="less">
.active {
  border: 1px solid #1890ff !important;
}
.head {
  height: 50px;
  background: #1890ff;
  span {
    float: right;
    line-height: 50px;
    margin-right: 25px;
    color: #fff;
    cursor: pointer;
  }
}
.situtionStyle {
  width: 813px;
  padding-left: calc((100vw - 1200px) / 2);
}
.situtionStyleWrapp {
  padding-bottom: 30px;
  height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
}
.insStyle {
  margin-top: 20px;
  background-color: #fffbe6;
  padding-left: 15px;
  height: 35px;
  line-height: 35px;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  font-weight: 400;
  width: 813px;
  font-style: normal;
  font-size: 14px;
  text-align: left;
}
.sureStyle {
  width: 100%;
  text-align: center;
  span {
    cursor: pointer;
    width: 150px;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    text-align: center;
    color: #fff;
    border-radius: 5px;
    background: #1777ff;
  }
}
@-moz-document url-prefix() {
  .btn {
    margin-left: 28px !important;
  }
}
.activeStyle {
  & {
    margin-left: 60px !important;
  }
  & + & {
    margin-left: 90px !important;
  }
  & + & + & {
    margin-left: 120px !important;
  }
  & + & + & + & {
    margin-left: 150px !important;
  }
  & + & + & + & + & {
    margin-left: 180px !important;
  }
  & + & + & + & + & + & {
    margin-left: 210px !important;
  }
  & + & + & + & + & + & + & {
    margin-left: 240px !important;
  }
  & + & + & + & + & + & + & + & {
    margin-left: 270px !important;
  }
  & + & + & + & + & + & + & + & + & {
    margin-left: 300px !important;
  }
  & + & + & + & + & + & + & + & + & + & {
    margin-left: 330px !important;
  }
  & + & + & + & + & + & + & + & + & + & + & {
    margin-left: 360px !important;
  }
  & + & + & + & + & + & + & + & + & + & + & + & {
    margin-left: 390px !important;
  }
  & + & + & + & + & + & + & + & + & + & + & + & + & {
    margin-left: 420px !important;
  }
}
/deep/ .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0px;
  margin-right: 8px;
}
</style>
